var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('LoadingIcon'):_c('CardStatusButton',{class:_vm.widgetStyle,attrs:{"data-test-id":`HomeWidgetSmall__${_vm.widgetType}`,"icon":_vm.widgetIcon,"iconPosition":"right","label":_vm.name,"title":_vm.metricValue,"type":_vm.widgetBorderType},on:{"click":_vm.handleActionButtonClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }